import { HTMLFromRichText, PrismicLink, TextFromRichText } from './PrismicTypes';

export const TEXT_LAYOUT_TWO = 'PrismicGenericTemplateDataBodyTwoTextLayout';
export const TEXT_LAYOUT_ONE = 'PrismicGenericTemplateDataBodyOneTextLayout';

export interface TextLayoutPrimary {
  text_layout_title: TextFromRichText;
  text_layout_content?: HTMLFromRichText;
  text_layout_primary_button_text?: TextFromRichText;
  text_layout_primary_button_link?: PrismicLink;
  text_layout_secondary_button_text?: TextFromRichText;
  text_layout_secondary_button_link?: PrismicLink;
  left_section_title?: TextFromRichText;
  left_section_content?: HTMLFromRichText;
  left_section_primary_button_text?: TextFromRichText;
  left_section_primary_button_link?: PrismicLink;
  left_section_secondary_button_text?: TextFromRichText;
  left_section_secondary_button_link?: PrismicLink;
  right_section_title?: TextFromRichText;
  right_section_content?: HTMLFromRichText;
  right_section_primary_button_text?: TextFromRichText;
  right_section_primary_button_link?: PrismicLink;
  right_section_secondary_button_text?: TextFromRichText;
  right_section_secondary_button_link?: PrismicLink;
  variant?: 'white' | 'mint' | 'grey';
}

export interface TextLayoutContent {
  __typename: typeof TEXT_LAYOUT_TWO | typeof TEXT_LAYOUT_ONE;
  primary: TextLayoutPrimary;
}
